export default {
	cixiangweibitianxiang: 'This item is required',
	dengluyihuode: 'Login for a more seamless process.',
	haimeiyouzhanghu: "Don't have an account yet? ",
	lijizhuce: 'Sign up now',
	xuanzebeishiwei: 'Selecting the option, you are deemed to have agreedto the',
	tiaokuan: 'Terms And Conditions',
	yinsishengming: 'Privacy Statement',
	yiji: 'and',
	huo: 'or',
	dianziyoujian: 'Email',
	mima: 'Password',
	dengru: 'Sign In',
	qudenglu: 'Go Sign In',
	zhuce: 'Register',
	zhucechenggong: 'Register Successful',
	buyizhi: 'Inconsistent',
	meiyoushoudao: "Didn't receive your email verification?",
	yikerenshenfen: 'Continue as guest',
	wangjimima: 'Forget password',
	zhanghao: 'Account',
	yanzhengzhanghao: 'Verify Account',
	yanzhengmima: 'Verify Password',
	yanzhengdianziyoujian: 'Verify Email',
	youketishi: 'By continuing as a guest, you agree to this website’s Terms, Data Policy and Cookies Policy.',
	chakan: 'View',
	xuanzeriqi: 'Select Dates',
	chufariqi: 'Departing date',
	huichengriqi: 'Returning date',
	chongshe: 'Reset',
	queren: 'Confirm',
	genggairiqi: 'Change Dates',
	hangban: 'Flights',
	yingfuzonge: 'Total amount Due',
	genggai: 'Changes',
	xianyoufujai: 'Existing Add-Ons',
	xinhangban: 'New Flight',
	zhifu: 'Pay',
	daojishi: 'Payment Countdown',
	zuoweiyiyuding: "We're sorry, this seat has been taken. Please select another seat",
	tianjiadaoyuding: 'Add to Booking',
	ewaituibukongjian: 'Extra Legroom seat, Row 10 Seat C',
	xinyongka: 'Credit Card',
	denglushiyongfacebook: 'Sign In With FaceBook',
	jiazaizhong: 'Loading',
	denglushibai: 'Login Fail!',
	zhuceshibai: 'Register Fail!',
	liru: 'Example',
	dengluchenggong: 'Login succeeded',
};
